import {useState,React} from 'react';
import './homepage.css';
import '../App.css';
import BottomBar from './BottomBar';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Projects from './Projects';
import Footer from './Footer'
import { Link } from 'react-router-dom';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CircularMenu from './CircularMenu';
import VideoModal from './VideoModal';
const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const Patents = () => {
    // const navigate = useNavigate();

    // function redirectToProjectsPage() {
    //     navigate('/projects', { replace: true });
    // }
    const [showModal, setShowModal] = useState(false);

const handleOpenModal = () => {
  setShowModal(true);
}

const handleCloseModal = () => {
  setShowModal(false);
}
    return (
        <div class="homepagedark">
      <div class="bg1">
        <div class="bg-item"></div>
        <div class="line-group">
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
        </div>
      </div>
      <div class="ololade-group">
        <div class="ololade2">
          <span>PATENTS/PUBLICATIONS</span>
          <span class="span2">.</span>
        </div>
        {/* <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button> */}
      </div>
      <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 680,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 830,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>
</div>
        
        
      </div>
      <b class="hello-my-name-container1">
        <p class="hello1">
          {/* <span>I’m a Product</span> */}
          <center>
          <img src='./patent.png' alt='Patent' style={{ height: '180px' }} />
          </center>
          <span class="span3"> </span>
          {/* <span class="designer1">Designer</span> */}
        </p>
      </b>
      

      <div class="i-like-to2">
        <center>
      A Temperature Retaining and Condensation Preventing Flask (Patent)<br></br>
Application Number: 202421007947<br></br>Filed: 06/02/2024<br></br>Published: 01/03/2024<br></br>Application Status: Published
</center>
      </div>
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 292,
    bottom: 0,
    right: 50,
  }}>
    <CircularMenu />
  </div>
</div>
    </div>
    );
};
export default Patents;